<template>
<div id="remove_limit" class="_main_container _remove_limit_bg">
    <div class="_remove_limit_header">
        <div class="_remove_limit_header_container">
            <img src="~images/logo_normal.svg" />
            <b>解除登录限制</b>
            <a href="login.html">登录</a>
        </div>
    </div>
    <div style="height:40px;">&nbsp;</div>
    <div class="remove_limit_frame">

        <div class="_retrieve_form_container">
            <p class="_common_form_row">
                <label>手机号</label>
                <input :class="{_er:v_loginId}" type="text" placeholder="输入手机号码" maxlength="11" v-model.trim="formData.loginId" @keyup.enter="submit()" @focus="focusInput('loginId')" @blur="blurInput('loginId')" />
                <span v-if="v_loginId" class="_common_form_row_tips">输入正确格式的手机号码</span>
            </p>
            <p class="_common_form_row">
                <label>手机验证码</label>
                <input :class="{_er:v_verifyCode}" type="text" placeholder="输入手机验证码" maxlength="6" v-model.trim="formData.verifyCode" @keyup.enter="submit()" @focus="focusInput('verifyCode')" @blur="blurInput('verifyCode')" />
                <button v-show="!countDown_show" @click="loginVerifyControl(true)">获取验证码</button>
                <button v-show="countDown_show" class="_disabled">{{countDownNum}}秒后重新获取</button>
                <span v-if="v_verifyCode" class="_common_form_row_tips">输入手机验证码</span>
            </p>
            <div class="_common_button">
                <a href="javascript:;" @click="submit()">解除限制</a>
            </div>
        </div>

    </div>

    <LoginVerify
        :is-show="loginVerifyShow"
        :validate="validate"
        :get-data="getDragVerification"
        @control="loginVerifyControl"
    ></LoginVerify>
</div>
</template>

<script>
import LoginVerify from '../../component/loginVerify'
import {getDragVerification,getUnlockUserSmsCode,unlockUserBySmsCode} from '../../api/index'
export default {
    components:{
        LoginVerify
    },
    data(){
        return{
            loginVerifyShow:false,//控制登录验证显示
            countDown_show:false,
            countDownNum:60,
            formData:{
                loginId:'',
                verifyCode:''
            },
            timer:null,
            taskId:'',
            v_loginId:false,
            v_verifyCode:false,
        }
    },
    methods:{
        focusInput(ele){

            this['v_'+ele] = false
        },
        blurInput(ele){

            let validate = true;

            if(!this.formData[ele]){
                validate = false;
            }
            if(ele === 'loginId'){
                let reg = new RegExp(/^1[3456789]\d{9}$/);
                if(!reg.test(this.formData[ele])){
                    validate = false;
                }
            }

            if(!validate){
                this['v_'+ele] = true
            }

            return validate
        },
        /**获取登录验证图片*/
        getDragVerification(){
            return new Promise((resolve,reject)=>{
                getDragVerification().then(res => {
                    res = res.data;
                    if (res.code === 0) {

                        let {
                            baseImageUrl,
                            sliderImageUrl,
                            height,
                            taskId,
                        } = res.content;
                        this.taskId = taskId;

                        resolve({
                            basePic: baseImageUrl,
                            sliderPic: sliderImageUrl,
                            picPartPositionY: height
                        })

                    } else {
                        $.userAlert(res.msg);
                        reject()
                    }
                }).catch(() => {
                    $.userAlert('网络错误，请刷新重试');
                    reject()
                })
            })
        },
        /**获取验证码接口*/
        validate(picCode){

            return new Promise((resolve,reject) => {
                getUnlockUserSmsCode({
                    picUUID:this.taskId,
                    picCode,
                    mobile:this.formData.loginId
                }).then(res=>{
                    res = res.data;
                    if(res.code === 0){

                        this.countDown_show = true;

                        if(this.timer){
                            clearInterval(this.timer);
                            this.timer = null;
                            this.countDownNum = 60;
                        }

                        this.timer = setInterval(()=>{

                            this.countDownNum --;

                            if(this.countDownNum === 0){

                                this.countDown_show = false;
                                clearInterval(this.timer);
                                this.timer = null;
                                this.countDownNum = 60;
                            }
                        },1050)

                        resolve()
                        $.userAlert('验证码已发送');
                    }else{
                        $.userAlert(res.msg);
                        reject()
                    }
                }).catch(() => {
                    $.userAlert('网络错误，请刷新重试');
                    reject()
                })
            })

        },
        /**提交*/
        submit(){

            if(!this.blurInput('loginId')) return;
            if(!this.blurInput('verifyCode')) return;

            unlockUserBySmsCode({
                mobile:this.formData.loginId,
                verifyCode:this.formData.verifyCode
            }).then(res=>{
                res = res.data;
                if(res.code === 0){
                    $.userAlert('登录限制解除成功！',function(){
                        location.href='login.html'
                    });
                }else{
                    $.userAlert(res.msg);
                }
            }).catch(() => {
                $.userAlert('网络错误，请刷新重试');
            })
        },
        /**登录验证控制*/
        loginVerifyControl(data){
            if(data){
                if(!this.blurInput('loginId')) return;
            }
            this.loginVerifyShow = data;
        },
    }
}
</script>

<style>
._remove_limit_bg{
    background-image: url("~images/register_bg.jpg");
}
._remove_limit_header{
    width: 100%;
    border-bottom:solid 1px #dedede;
    background-color: #fff;
}
._remove_limit_header_container{
    clear: both;
    width:1200px;
    height:68px;
    margin: 0 auto;
    position: relative;
}
._remove_limit_header_container>img{
    display:inline-block;
    height: 58px;
    margin-top: 5px;
}
._remove_limit_header_container>b{
    display:inline-block;
    font-size: 1.4rem;
    margin-left: 10px;
    padding-left: 10px;
    color:#333;
    font-weight: normal;
    border-left: solid 1px #333;
    position: relative;
    top: -22px;
}
._remove_limit_header_container>a{
    display:inline-block;
    font-size:1.4rem;
    color:#333;
    text-decoration: underline;
    position: absolute;
    top: 26px;
    right:0px;
}
.remove_limit_frame{
    width: 30%;
    margin: 0 auto;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px #ddd;
    position: relative;
}
._retrieve_form_container{
    width:80%;
    margin: 0 auto;
    padding:20px 0px;
}
</style>



// WEBPACK FOOTER //
// src/component/sign/RemoveLimit.vue